module.exports = __webpack_public_path__ + "img/noregister_top@2x.0266f5c5.png";